/* eslint-disable */
import _ from 'underscore';
import Backbone from 'backbone';
import Options from '@bingads-webui-component-legacy/grid/model/index';
import WindowContainer from '@bingads-webui-component-legacy/grid/windowContainer';
import ElementContainer from '@bingads-webui-component-legacy/grid/elementContainer';

// refer https://stackoverflow.com/a/67840046
function elemToSelector(elem) {
  const {
    tagName,
    id,
    className,
    parentNode
  } = elem;

  if (tagName === 'HTML') return 'HTML';

  let str = tagName;

  str += (id !== '') ? `#${id}` : '';

  if (className) {
    const classes = className.split(/\s/);
    for (let i = 0; i < classes.length; i++) {
      const classSelector = classes[i] ? `.${classes[i]}` : '';
      str += classSelector;
    }
  }

  let childIndex = 1;

  for (let e = elem; e.previousElementSibling; e = e.previousElementSibling) {
    childIndex += 1;
  }

  str += `:nth-child(${childIndex})`;

  return `${elemToSelector(parentNode)} > ${str}`;
}

var Grid = Backbone.View.extend({
  initialize: function (options) {
    options = options || ({});
    this.options = new Options(options);
    var container = selectContainer(options.container);
    this.layout = new options.layout({
      el: this.el,
      grid: this,
      container: container
    });
    this.projection = _.isFunction(options.projection) ? new options.projection() : options.projection;
    this.projection.data.on('change', (function (arg) {
      this.trigger.apply(this, ['change:data'].concat(_.toArray(arguments)));
    }).bind(this));
    this.options.on('change', (function () {
      this.trigger.apply(this, ['change:options'].concat(_.toArray(arguments)));
    }).bind(this));
    this.projection.on('all', (function () {
      this.trigger.apply(this, ['data:' + _.first(arguments)].concat(_.rest(arguments)));
    }).bind(this));
    this.layout.on('all', (function () {
      var key = 'layout:' + _.first(arguments), arg = [key].concat(_.rest(arguments));
      this.projection.bubble.apply(this.projection, arg);
      this.trigger.apply(this, arg);
    }).bind(this));
    this.on('layout:click:header', (function (e, arg) {
      var column = arg.column;
      if (column.sortable) {
        var orderby = {};
        var key = _.isString(column.sortable) ? column.sortable : column.property;
        orderby[key] = column.$orderby ? column.$orderby.dir * -1 : 1;
        const selector = elemToSelector(document.activeElement);
        this.projection.set({
          'orderby': [orderby],
          'page.number': 0
        });
        document.querySelector(selector).focus();
      }
    }).bind(this));
    var local = _.omit(options, 'projection', 'layout');
    this.options.set(local);
  },
  remove: function () {
    this.layout.remove();
    Backbone.View.prototype.remove.apply(this, arguments);
  },
  set: function (key, value, options) {
    this.options.set.apply(this.options, _.toArray(arguments));
  },
  render: function (options) {
    var options = options || ({});
    this.layout.render();
    if (options.fetch) {
      this.projection.update({
        deep: true
      });
    }
    return this;
  },
  rerender: function () {
    this.layout.rerender();
  }
});
function selectContainer(userContainer) {
  if (userContainer && window !== userContainer && ElementContainer.isValidContainer(userContainer)) {
    return new ElementContainer({
      el: userContainer
    });
  }
  return new WindowContainer();
}
export default Grid;

